import { MDSChip, MDSIcon } from '@marqvision/mds-v2';
import { FilterChipProps } from './@types';
import { getSelectedTags } from './@utils';

export const FilterChip = (props: FilterChipProps) => {
  const { type, color = 'bluegray', label, selected, startIcon: _startIcon, ...restProps } = props;

  const isSelected = Boolean(Array.isArray(selected) ? selected.length : selected);
  const chipVariant = isSelected ? 'fill' : 'tint';
  const startIcon = type === 'toggle' && isSelected ? <MDSIcon.Check variant="outline" /> : _startIcon;
  const endIcon = type !== 'toggle' ? <MDSIcon.ArrowDown variant="outline" /> : undefined;
  const tags = getSelectedTags(props);

  return (
    <MDSChip
      variant={chipVariant}
      size="medium"
      color={color}
      startIcon={startIcon}
      endIcon={endIcon}
      tags={tags || undefined}
      {...restProps}
    >
      {label}
    </MDSChip>
  );
};

/*
* 예시 코드
*
* - Toggle
  <FilterChip
    type="toggle"
    color="bluegray"
    label="Filter label"
    selected={isSelected}
    onClick={() => setIsSelected(isSelected ? null : true)}
  />
*
* - Select
  <MDSDropDown
    value={dropdownValue}
    list={dropdownList}
    renderAnchorComponent={(value, handleOpen) => (
      <FilterChip
        type="select"
        color="bluegray"
        label="Filter label"
        selected={value}
        dropdownList={dropdownList}
        onClick={handleOpen}
      />
    )}
  />
*
* - Other
  <>
    <FilterChip
      type="other"
      color="bluegray"
      label="Filter label"
      selected={selectedLabel}  // tag 에 보여질 text
      onClick={(e) => setAnchorEl(e.currentTarget as HTMLElement)}
    />
    {anchorEl && (
      <TimecodeRangePicker
        anchorEl={anchorEl}
        value={{ min: filter?.min || null, max: filter?.max || null }}
        onApply={handleApply}
        onClose={() => setAnchorEl(null)}
      />
    )}
  </>
* */